let scrollTop = 0;
let set = [];

const pageScrollCtrl = {
  lock(name) {
    if (!set.length) {
      scrollTop = document.documentElement.scrollTop
        || window.pageYOffset
        || document.body.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.top = `${-scrollTop}px`;
    }
    set.push(name);
    console.log(set);
  },
  unlock(name) {
    let i = set.indexOf(name);
    console.log(i);
    if (i > -1) {
      set.splice(i, 1);
    }

    if (!set.length) {
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, scrollTop); // 回到原先的top
    }
    console.log(set);
  }
};

export default pageScrollCtrl;

